export const BAIGOLFHOST = 'BAIGOLFHOST';
export const USERDATA = 'USERDATA';
export const USERWALLET = 'USERWALLET';
export const ROUTERNAME = 'ROUTERNAME';



// WEBPACK FOOTER //
// ./src/store/mutations_type.js